import { getSafe } from "./safe";

/**
 * Get supported locale (placeholder implementation)
 * @returns {string} Default locale
 */
export function supportedLocal() {
  //const current = getLang()

  //if (SUPPORTED_LOCALS.indexOf(current) > -1) {
  //  return current
  //}
  return "en";
}

/**
 * Convert city slug to localized name
 * @param {string} slug - City slug
 * @param {Array} cities - Array of city objects
 * @param {string} local - Locale code
 * @returns {string} Localized city name or slug as fallback
 */
export function citySlugToName(slug, cities, local) {
  return (
    getSafe(() => cities.filter((c) => c.slug === slug)[0].title[local]) || slug
  );
}